var _rect, _rect2, _path, _path2, _path3, _path4, _g, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlooLogoOption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 19,
    viewBox: "0 0 39 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666341,
    y: 1.1097,
    width: 37.4454,
    height: 17.5189,
    rx: 8.75944,
    fill: "#171717"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.666341,
    y: 1.1097,
    width: 37.4454,
    height: 17.5189,
    rx: 8.75944,
    stroke: "url(#paint0_linear_5556_40983)",
    strokeWidth: 0.481119
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7909 4.7168H12.7383V12.4615H13.7909V4.7168Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4882 11.6297C16.4981 11.6297 15.7869 10.8429 15.7869 9.86496C15.7869 8.91514 16.4924 8.13392 17.4882 8.13392C18.4612 8.13392 19.1554 8.92076 19.1554 9.86496C19.1554 10.8429 18.4612 11.6297 17.4882 11.6297ZM17.4882 7.17285C15.912 7.17285 14.7285 8.38121 14.7285 9.86496C14.7285 11.3712 15.9064 12.5908 17.4882 12.5908C19.0416 12.5908 20.2137 11.3712 20.2137 9.86496C20.2137 8.38121 19.0473 7.17285 17.4882 7.17285Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6796 11.6297C22.6895 11.6297 21.9783 10.8429 21.9783 9.86496C21.9783 8.91514 22.6838 8.13392 23.6796 8.13392C24.6526 8.13392 25.3468 8.92076 25.3468 9.86496C25.3468 10.8429 24.6526 11.6297 23.6796 11.6297ZM23.6796 7.17285C22.1035 7.17285 20.9199 8.38121 20.9199 9.86496C20.9199 11.3712 22.0978 12.5908 23.6796 12.5908C25.233 12.5908 26.4051 11.3712 26.4051 9.86496C26.4051 8.38121 25.2387 7.17285 23.6796 7.17285Z",
    fill: "url(#paint1_linear_5556_40983)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19922 9.86496C6.19922 11.3712 7.38275 12.5908 8.95889 12.5908C9.60187 12.5908 10.1709 12.3828 10.6261 12.0344V12.4109C10.6261 13.6193 10.0286 14.0464 8.93613 14.0464L8.94751 15.0188C10.3017 15.0188 11.673 14.5579 11.673 12.1749V7.21781H10.6773L10.6318 7.72364C10.1766 7.3808 9.60187 7.17285 8.96458 7.17285C7.38275 7.17285 6.19922 8.38121 6.19922 9.86496ZM8.95889 11.6297C7.96313 11.6297 7.25757 10.8429 7.25757 9.86496C7.25757 8.91514 7.96313 8.13392 8.95889 8.13392C9.93189 8.13392 10.6261 8.92076 10.6261 9.86496C10.6261 10.8485 9.93189 11.6297 8.95889 11.6297Z",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5556_40983)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4515 7.19576C30.2901 7.16724 30.1239 7.15234 29.9542 7.15234C29.7637 7.15234 29.5776 7.1711 29.3979 7.20684V9.37804L27.2199 9.37804C27.1896 9.5389 27.1738 9.70472 27.1738 9.87416C27.1738 10.0652 27.1939 10.2517 27.2322 10.4316H29.3979V12.5415C29.5776 12.5772 29.7637 12.596 29.9542 12.596C30.1239 12.596 30.2901 12.5811 30.4515 12.5526V10.4316H32.6761C32.7144 10.2517 32.7345 10.0652 32.7345 9.87416C32.7345 9.70472 32.7187 9.5389 32.6884 9.37804L30.4515 9.37804V7.19576Z",
    fill: "url(#paint2_linear_5556_40983)",
    fillOpacity: 0.56
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4514 7.22016C30.2901 7.19165 30.1239 7.17676 29.9542 7.17676C29.7636 7.17676 29.5776 7.19552 29.3978 7.23126V9.40147L27.2201 9.40147C27.1897 9.56264 27.1738 9.72879 27.1738 9.89857C27.1738 10.0893 27.1939 10.2754 27.232 10.4551H29.3978V12.5659C29.5776 12.6016 29.7636 12.6204 29.9542 12.6204C30.1239 12.6204 30.2901 12.6055 30.4514 12.577V10.4551H32.6764C32.7145 10.2754 32.7345 10.0893 32.7345 9.89857C32.7345 9.72879 32.7186 9.56264 32.6883 9.40147L30.4514 9.40147V7.22016Z",
    fill: "url(#paint3_linear_5556_40983)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5556_40983",
    x: 25.1836,
    y: 5.16216,
    width: 9.54091,
    height: 9.42372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.99509,
    result: "effect1_foregroundBlur_5556_40983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5556_40983",
    x1: 0.425781,
    y1: 10.7321,
    x2: 38.4341,
    y2: 10.0104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67C586"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5556_40983",
    x1: 24.8717,
    y1: 10.2777,
    x2: 27.1545,
    y2: 10.2777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67C586"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5556_40983",
    x1: 27.1738,
    y1: 10.0205,
    x2: 32.7345,
    y2: 10.0205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#67C586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5556_40983",
    x1: 27.1738,
    y1: 10.0449,
    x2: 32.7345,
    y2: 10.0449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#67C586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5F3FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlooLogoOption);
export default __webpack_public_path__ + "static/media/gloo-logo-option.4f5f828fef6f423d6cf7c922240e62ab.svg";
export { ForwardRef as ReactComponent };